

import { AggregateWindow, FilterPoint, Point } from "../../features/filter/types/types"
import { getTodayDate } from "../../features/filter/utils/dateUtils"
import { converteTimeToDay, converteTimeToString } from "./time.utils"

  
export const createList = (aggregation:AggregateWindow, filter: FilterPoint,  data: Point[] | undefined ) => {
    const listx = []
 
    const startDate = filter.startDate

    if (aggregation ==='1mo'){
      const startDateObj = new Date(filter.startDate || new Date().toISOString());
      const stopDateObj = new Date(filter.stopDate || new Date().toISOString());
      
      // Vérifier que les dates sont valides
      if (isNaN(startDateObj.getTime()) || isNaN(stopDateObj.getTime())) {
        console.warn('Invalid dates in graph.utils (1mo):', { startDate: filter.startDate, stopDate: filter.stopDate });
        return { listx: [], listValue: [] };
      }
      
      const nbMonth = nbMonthBewteenDate(startDateObj, stopDateObj)
      
      for (let i = 0; i <= nbMonth ; i++){
        const legend = getTodayDate({currentDate:startDate || undefined, nbMonth: i,  resetHour: true})
        listx.push(legend)

      }
    }

    if (aggregation ==='15m'){
      const startDateObj = new Date(filter.startDate || new Date().toISOString());
      const stopDateObj = new Date(filter.stopDate || new Date().toISOString());
      
      // Vérifier que les dates sont valides
      if (isNaN(startDateObj.getTime()) || isNaN(stopDateObj.getTime())) {
        console.warn('Invalid dates in graph.utils (15m):', { startDate: filter.startDate, stopDate: filter.stopDate });
        return { listx: [], listValue: [] };
      }
      
      const diffInMs = Math.abs(stopDateObj.getTime() - startDateObj.getTime());
      const diffInMinutes = diffInMs / (1000 * 60);
      const nbIntervals = Math.floor(diffInMinutes / 15);

      for (let i = 0; i <= nbIntervals; i++){
        const currentDate = new Date(startDateObj);
        const minutesToAdd = i * 15;
        currentDate.setUTCMinutes(startDateObj.getUTCMinutes() + minutesToAdd);
        // Arrondir à l'intervalle de 15 minutes
        const roundedMinutes = Math.floor(currentDate.getUTCMinutes() / 15) * 15;
        currentDate.setUTCMinutes(roundedMinutes);
        currentDate.setUTCSeconds(0);
        currentDate.setUTCMilliseconds(0);
        listx.push(currentDate.toISOString());
      }
    }

    if (aggregation ==='1h'){
      const startDateObj = new Date(filter.startDate || new Date().toISOString());
      const stopDateObj = new Date(filter.stopDate || new Date().toISOString());
      
      // Vérifier que les dates sont valides
      if (isNaN(startDateObj.getTime()) || isNaN(stopDateObj.getTime())) {
        console.warn('Invalid dates in graph.utils (1h):', { startDate: filter.startDate, stopDate: filter.stopDate });
        return { listx: [], listValue: [] };
      }
      
      // Normaliser la date de début à 0h UTC
      const normalizedStartDate = new Date(Date.UTC(
        startDateObj.getUTCFullYear(),
        startDateObj.getUTCMonth(),
        startDateObj.getUTCDate(),
        0, 0, 0, 0
      ));
      
      const NbHour = nbHourBewteenDate(startDateObj, stopDateObj)

      for (let i = 0; i < NbHour ; i++){
        // Créer une nouvelle date à partir de la date normalisée et ajouter i heures
        const currentDate = new Date(normalizedStartDate);
        currentDate.setUTCHours(currentDate.getUTCHours() + i);
        listx.push(currentDate.toISOString())
      }
    }

    if (aggregation ==='1d'){
      const startDateObj = new Date(startDate || new Date().toISOString());
      const stopDateObj = new Date(filter.stopDate || new Date().toISOString());
      
      // Vérifier que les dates sont valides
      if (isNaN(startDateObj.getTime()) || isNaN(stopDateObj.getTime())) {
        console.warn('Invalid dates in graph.utils (1d):', { startDate, stopDate: filter.stopDate });
        return { listx: [], listValue: [] };
      }

      const nbDay = getNbDayBeetwenDate(startDateObj, stopDateObj)

      
  
      for (let i = 0; i <=  nbDay; i++){
        const legend = getTodayDate({currentDate:startDate || undefined, nbDay: i, resetHour: true})
        listx.push(legend)
    }
      
      // Debug: vérifier les dates générées
      if (listx.length > 0) {
        console.log('Dates générées pour 1d:', listx.slice(0, 3), '...', listx.slice(-3));
        console.log('Données reçues:', data?.slice(0, 3)?.map(d => ({ Time: d.Time, Value: d.Value })));
      }



    }


    const listValueF = listx.map((item) => {
      const itemFind = data?.find((itemData) => {
        const date = new Date(itemData.Time)
        const dateLegend = new Date(item)
 
        // Normaliser les dates à minuit UTC pour la comparaison (pour l'agrégation 1d)
        if (aggregation === '1d') {
          const normalizedDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));
          const normalizedLegend = new Date(Date.UTC(dateLegend.getUTCFullYear(), dateLegend.getUTCMonth(), dateLegend.getUTCDate(), 0, 0, 0, 0));
          return compareDate(normalizedDate, normalizedLegend, aggregation as AggregateWindow);
        }
        
        // Normaliser les heures (minutes et secondes à 0) pour la comparaison (pour l'agrégation 1h)
        if (aggregation === '1h') {
          const normalizedDate = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), 0, 0, 0));
          const normalizedLegend = new Date(Date.UTC(dateLegend.getUTCFullYear(), dateLegend.getUTCMonth(), dateLegend.getUTCDate(), dateLegend.getUTCHours(), 0, 0, 0));
          return compareDate(normalizedDate, normalizedLegend, aggregation as AggregateWindow);
        }
        
        if (compareDate(date, dateLegend, aggregation as AggregateWindow)){
          return true
        }
        return false
      })
      return itemFind?.Value ?? null
    })



    return {listx, listValue : listValueF }

  }
  
  

  

  
  const getNbDayBeetwenDate = (date1: Date, date2: Date) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays
  
  }
  
  const nbMonthBewteenDate = (date1: Date, date2: Date) => {
    const yearDiff = date2.getUTCFullYear() - date1.getUTCFullYear();
    const monthDiff = date2.getUTCMonth() - date1.getUTCMonth();
    return monthDiff + (12 * yearDiff);
  }
  
  const nbHourBewteenDate = (date1: Date, date2: Date) => {
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffHours = diffTime / (1000 * 60 * 60); 
    return diffHours;
  
  }
  
  const compareDate = (date1: Date, date2: Date, aggregateWindow: AggregateWindow) => {
  
    if (aggregateWindow === '1mo'){
      return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth()
    }
  
    if (aggregateWindow === '1d'){
      return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate()
    }
  
    if (aggregateWindow === '1h'){
  
      return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate() && date1.getUTCHours() === date2.getUTCHours()
    }

    if (aggregateWindow === '15m'){
      // Comparer les dates en arrondissant les minutes à l'intervalle de 15 minutes
      const minutes1 = Math.floor(date1.getUTCMinutes() / 15) * 15;
      const minutes2 = Math.floor(date2.getUTCMinutes() / 15) * 15;
      return date1.getUTCFullYear() === date2.getUTCFullYear() 
      && date1.getUTCMonth() === date2.getUTCMonth() 
      && date1.getUTCDate() === date2.getUTCDate()
      && date1.getUTCHours() === date2.getUTCHours()
      && minutes1 === minutes2
    }
  
      return date1.getUTCFullYear() === date2.getUTCFullYear() 
      && date1.getUTCMonth() === date2.getUTCMonth() 
      && date1.getUTCDate() === date2.getUTCDate()
      && date1.getUTCHours() === date2.getUTCHours()
      && date1.getUTCMinutes() === date2.getUTCMinutes()
      && date1.getUTCSeconds() === date2.getUTCSeconds()
  }


export const converteTitle = (startDate: string, stopDate: string) => {

  
    return 'Du '+converteTimeToDay(startDate)+' au ' + converteTimeToDay(stopDate)
  }
  
  
  
  export const convertTimeType= (aggregateWindow: AggregateWindow) => {
      switch (aggregateWindow) {
          case '15m':
              return '15m'
          case '1mo':
              return 'mo'
          case '1h':
              return 'h'
          case '1d':
              return 'd'
          case '1y':
              return 'y'
          default:
              return 'mo'
      }
  }
  
  export const converteTimetoName = (time: string, aggregateWindow:  AggregateWindow) => {
  
    return converteTimeToString(time, convertTimeType(aggregateWindow))
  }
  